import { Box, Typography, Link } from "@mui/material"

const Highlight = ({ content, title, subtitle, year, link=null, align="left" }) => {
  return(
    <Box pl={2} pr={2}>
      <Box>
        {content}
      </Box>
      <Box m={1}></Box>
      <Box style={{ textAlign: align }} pl={align === "left" ? {xs: 0, sm: 4} : 0} pr={align === "right" ? {xs: 0, sm: 4} : 0}>
        <Box maxWidth={500} display="inline-block" fontFamily="General Sans">
          <Typography fontSize="1.1rem">
            {title}
          </Typography>
            {subtitle}
          <Typography fontFamily="inherit" fontSize="0.9rem">
            ({year})
          </Typography>
          {link !== null && (
            <Link 
              href = {link}
              target = "_blank"
              rel = "noreferrer"
              sx = {{
                "textDecoration": "none",
                "cursor": "crosshair",
                "&:hover": {
                  "textDecoration": "underline"
                }
              }}
            >
              <Typography fontFamily="inherit" fontSize="0.9rem">
                see more
              </Typography>
            </Link>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default Highlight